import axios from "axios";
import axiosRetry from "axios-retry";
import toast from "react-hot-toast";

const ApiRoot = `${process.env.REACT_APP_ENGAGEMENT_API_ROOT}/adhocsurvey`;

axiosRetry(axios, {
	retries: 5,
	retryDelay: (retryCount) => retryCount * 3000,
});

export async function getAllAdHocSurveysAsync() {
	try {
		const result = await axios.get(ApiRoot);
		return result.data;
	} catch {
		toast.error("Error listing ad-hoc surveys please try again");
		return [];
	}
}

export async function getAdHocSurveyByIdAsync(id) {
	try {
		const result = await axios.get(`${ApiRoot}/${id}`);
		return result.data;
	} catch {
		toast.error("Error loading ad-hoc survey please try again");
		return {};
	}
}

export async function createAdHocSurveyAsync(survey) {
	let success = true;
	let isSurveyMissing = false;

	survey.rules = survey.rules.toString();

	try {
		const result = await axios.post(ApiRoot, survey);
		if (result.status !== 201) success = false;
	} catch (exception) {
		if (exception.response.status === 409) {
			survey.rules = survey.rules.split(",");
			isSurveyMissing = true;
		}

		success = false;
	}

	if (success) toast.success("Ad-hoc survey created successfully");
	else toast.error("Error creating ad-hoc survey please try again");

	return { success, isSurveyMissing };
}

export async function updateAdHocSurveyAsync(id, survey) {
	let success = true;
	let isSurveyMissing = false;

	survey.rules = survey.rules.toString();

	try {
		const result = await axios.put(`${ApiRoot}/${id}`, survey);
		if (result.status !== 200) success = false;
	} catch (exception) {
		if (exception.response.status === 409) {
			survey.rules = survey.rules.split(",");
			isSurveyMissing = true;
		}

		success = false;
	}

	if (success) toast.success("Ad-hoc survey updated successfully");
	else toast.error("Error updating ad-hoc survey please try again");

	return { success, isSurveyMissing };
}

export async function deleteAdHocSurveyAsync(id) {
	let success = true;
	let isConflicted = false;
	let conflicts = [];

	try {
		const result = await axios.delete(`${ApiRoot}/${id}`);
		if (result.status !== 204) success = false;
	} catch (exception) {
		if (exception.response.status === 409) {
			isConflicted = true;
			conflicts = exception.response.data;
		}

		success = false;
	}

	if (success) toast.success("Ad-hoc survey deleted successfully");
	else toast.error("Error deleting ad-hoc survey please try again");

	return { success, isConflicted, conflicts };
}

export async function refreshAdHocSurveyMetadata(id) {
	let success = true;

	try {
		const result = await axios.put(`${ApiRoot}/${id}/metadata`);
		if (result.status !== 200) success = false;
	} catch (_exception) {
		success = false;
	}

	if (success) toast.success("Metadata refresh was requested successfully, this may take a few minutes to complete");
	else toast.error("Error refreshing metadata refresh please try again");
}
